<template>
  <div>
    <div class="CompletionStatusTable">
      <el-table
        :data="list"
        :max-height="370"
        ref="scroll_Table"
        style="width: 420px"
        :border="false"
        :header-cell-style="{
          color: '#333',
          borderColor: '#ddd',
          backgroundColor: 'transparent',
          borderColor: '#e2c6c0',
        }"
        :cell-style="{
          backgroundColor: 'transparent',
          borderColor: '#e2c6c0',
        }"
        :row-style="{
          backgroundColor: 'transparent',
          borderColor: '#e2c6c0',
        }"
        @cell-click="handleCellClick"
        @mouseenter.native="autoScroll(true)"
        @mouseleave.native="autoScroll(false)"
        ><el-table-column
          prop="category"
          label="时间"
          width="width"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="count"
          label="服务完成人次"
          width="width"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>

    <DialogUserTable
      :show.sync="visible"
      :tableData="userList"
      @onSelect="onCheckoutItemOfUser"
      :title="title"
      showTitle
    ></DialogUserTable>

    <DialogArchivesCard
      :id="checkUsers.sn"
      :show.sync="visibleArchives"
      @back="visible = true"
    ></DialogArchivesCard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

import DialogUserTable from "./DialogUserTable.vue";
import DialogArchivesCard from "./DialogArchivesCard.vue";

export default {
  data() {
    return {
      loading: false,
      visible: false,
      visibleArchives: false,
      userList: [],
      checkUsers: {},
      title: "",
      scrolltimer: "", // 自动滚动的定时任务
      // list: [
      //   {
      //     category: "助医",
      //     count: 134,
      //   },
      //   {
      //     category: "助餐",
      //     count: 22,
      //   },
      //   {
      //     category: "助行 ",
      //     count: 344,
      //   },
      //   {
      //     category: "助购",
      //     count: 55,
      //   },
      //   {
      //     category: "助洁",
      //     count: 66,
      //   },
      //   {
      //     category: "助浴",
      //     count: 85,
      //   },
      //   {
      //     category: "助乐",
      //     count: 23,
      //   },
      //   {
      //     category: "助急",
      //     count: 44,
      //   },
      // ],
    };
  },

  components: {
    DialogUserTable,
    DialogArchivesCard,
  },
  computed: {
    ...mapGetters(["globalData", "mapKey", "communityKey", "plotKey"]),
    list() {
      let orderMonthCount = this.globalData.orderMonthCount || [];
      return this.transformData(orderMonthCount);
    },
  },

  watch: {
    list: {
      handler(n) {
        if (n && n.length) {
          this.$nextTick(() => {
            this.autoScroll();
          });
        }
      },
      deep: true,
    },
  },
  mounted() {},
  beforeDestroy() {
    this.autoScroll(true);
  },
  methods: {
    handleCellClick(row) {
      this.getUserList(row.category);
    },
    onCheckoutItemOfUser(row) {
      this.checkUsers = row;
      // this.getArchivesDetail();
      this.visible = false;
      this.visibleArchives = true;
    },
    transformData(data) {
      if (!data) return [];
      return data.map((item) => {
        // 获取对象的键和值
        let category = Object.keys(item)[0];
        let count = item[category];

        // 构建新的对象结构
        return {
          category: category,
          count: count,
        };
      }).filter(v => {
        return !["2024年01月", "2024年02月", "2024年03月", "2024年04月", "2024年05月", "2024年06月", "2024年07月", "2024年08月", "2024年09月"].includes(v.category);
      });
    },

    getUserList(mouth) {
      this.$axios
        .get("/statisticsService/mechanism/orderUsers", {
          params: {
            subDistrict: this.mapKey,
            community: this.communityKey,
            village: this.plotKey,
            month: mouth,
          },
        })
        .then((res) => {
          this.userList = res.data;
          this.visible = true;
        });
    },

    // 设置自动滚动
    autoScroll(stop) {
      if (this.scrolltimer) {
        window.clearInterval(this.scrolltimer);
      }
      const table = this.$refs.scroll_Table;
      // 拿到表格中承载数据的div元素
      const divData = table.$refs.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      if (stop) {
        //再通过事件监听，监听到 组件销毁 后，再执行关闭计时器。
        window.clearInterval(this.scrolltimer);
      } else {
        this.scrolltimer = window.setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 1;
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          // console.log("可视高度", divData.clientHeight);
          // console.log("距离顶部", divData.scrollTop);
          // console.log("整个高度", divData.scrollHeight);
          // console.log("************");

          if (
            parseInt(divData.clientHeight) + parseInt(divData.scrollTop) ==
            parseInt(divData.scrollHeight)
          ) {
            // 重置table距离顶部距离
            divData.scrollTop = 0;
            // 重置table距离顶部距离。值=(滚动到底部时，距离顶部的大小) - 整个高度/2
            // divData.scrollTop = divData.scrollTop - divData.scrollHeight / 2
          }
        }, 150); // 滚动速度
      }
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .CompletionStatusTable {
    .el-table,
    .el-table__expanded-cell {
      background-color: transparent !important;
      border-bottom: 1px solid @border-color;
    }
    .el-table .thead {
      background-color: transparent !important;
    }
    .el-table tr {
      background: transparent !important;
    }
  }
}
</style>
